// extracted by mini-css-extract-plugin
export default {"lineWrapper":"Auth_lineWrapper__bWGu2"};